import { GoogleTagService } from '@apparel/ui/lib/GoogleTag';
import { useReactRouter } from '@hooks/useRouter';
import { Order } from '@model/Order';
import { designRequestStepCommit } from '@redux/Designs/actions';
import { forEach, get } from 'lodash';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { route } from '@packages/router';
import { GTag } from '@apparel/ui/lib/utils';

const ITEM_FIELDS = [
    'id',
    'package_id',
    'sku_id',
    'category_id',
    ['category', ['name']],
    'subcategory_id',
    'quantity',
    ['sku', 'id,name,preview_photo,subcategory_id,is_sizing_kit', ['category', 'id,name']],
];

const SALESMAN_FIELDS = ['id', ['user', 'first_name,last_name,email']];

/**
 * React Hooks effect used to pass IQ data to Design Request
 */
export function useInstantQuoteToDesignRequest() {
    const dispatch = useDispatch();
    const { history } = useReactRouter();
    const [isLoadingPreFill, setLoadingPreFill] = useState(false);

    const handlePreFillDesignRequest = (orderId) => async () => {
        setLoadingPreFill(true);

        // $FlowFixMe
        const { data } = await Order.find(orderId, {
            fields: [
                'id',
                'name',
                'total',
                'subtotal',
                'shipping_cost',
                ['salesman', SALESMAN_FIELDS],
                ['items', ITEM_FIELDS],
            ],
        });
        const packages = {};
        const items = data.items;

        const extras = {};
        items
            .filter((item) => !item.sku.is_sizing_kit)
            .forEach((item) => {
                if (item.package_id) {
                    if (!packages[item.package_id]) {
                        packages[item.package_id] = {
                            id: item.package_id,
                            category_id: item.category_id,
                            quantity: item.quantity,
                            subcategories: [],
                        };
                    }

                    packages[item.package_id].subcategories.push({
                        sku_id: get(item, 'sku_id'),
                        default_sku: get(item, 'sku'),
                        subcategory_id: get(item, 'subcategory_id'),
                    });
                } else if (item.sku_id) {
                    extras[item.sku_id] = {
                        id: item.sku_id,
                        category_id: item.category_id,
                        subcategory_id: item.subcategory_id,
                        quantity: item.quantity,
                    };
                }
            });

        const payload = {
            products: {
                category_id: items[0].category_id,
                category_name: items[0].category?.name,
                packages,
                extras,
            },
        };

        forEach(payload, (data, key) => {
            dispatch(
                designRequestStepCommit({
                    state: data,
                    tab: { key },
                }),
            );
        });
        GoogleTagService.reportConversion(GTag.Design_Request_Started);
        setLoadingPreFill(false);

        history.push(
            route('Designs.Request.Create', {
                id: 'view',
                step: 'quantities',
            }),
        );
    };

    return {
        handlePreFillDesignRequest,
        isLoadingPreFill,
    };
}
